export default class SdkConfig {
  static config = {
    debug: false,
    collectEventDelegator: undefined,
    version: __VERSION__,
    buildDate: __BUILD_DATE__
  }

  static initConfig(sdkConfig) {
    SdkConfig.config = { ...SdkConfig.config, ...sdkConfig }
    if (this.isDebugMode()) {
      console.debug('###DEBUG >> init SDK Config --> ', SdkConfig.config)
    }
  }

  static isDebugMode() {
    return SdkConfig.config?.debug
  }
}
